import { useSelector } from "react-redux";

export const useLocation = () => {
    return useSelector((state) => state.location);
};
